import HeaderLogo from "../images/troll.png"

export default function Header() {
    return (
        <div className="header-container">
            <img src={HeaderLogo} alt="troll" className="header-logo"></img>
            <div className="header-title">Meme Generator</div>
            <div className="header-course">React Course-Project 3</div>
        </div>
    )
}